import { setupWorker } from 'msw/browser';

import { mocks } from '../api/mocks';


export const worker = setupWorker(...mocks);
